import { Typography } from '@mui/material';

export default function FlowChartOfHowItWorkTitle({ title, ...otherProps }) {
  return (
    <Typography variant="h2" {...otherProps}>
      {title}
    </Typography>
  );
}
